/* ============================================================
   CALCULATEUR CAPACITÉ CANTILEVER — hero DA (fiche 2 zones)
   charge max = capacité/bras × (niveaux × colonnes)
   mètres linéaires = niveaux × colonnes × entraxe
   ============================================================ */
(function () {
  'use strict';
  const root = document.getElementById('calc-canti-root');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const bras = $('#ca-bras');
  const niveaux = $('#ca-niveaux');
  const colonnes = $('#ca-colonnes');
  const entraxe = $('#ca-entraxe');
  const btn = $('#ca-go');
  const results = $('#ca-results');
  const summary = $('#ca-summary');

  const fmt = (n) => Math.round(n).toLocaleString('fr-FR');
  const fmtT = (kg) => (kg / 1000).toFixed(1).replace('.', ',');
  const fmt1 = (n) => n.toFixed(1).replace('.', ',');
  const arrow = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
  const pencil = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4z"/></svg>';

  function showForm() { root.classList.remove('is-calculated'); results.hidden = true; bras.focus(); }

  function calculate() {
    const cb = parseFloat(bras.value);
    const N = parseInt(niveaux.value, 10), C = parseInt(colonnes.value, 10);
    const E = parseFloat(entraxe.value);
    if (!cb || !N || !C || !E || cb <= 0 || N <= 0 || C <= 0 || E <= 0) {
      root.classList.remove('is-calculated'); results.hidden = true;
      [bras, niveaux, colonnes, entraxe].forEach((i) => { if (!i.value) i.reportValidity && i.reportValidity(); });
      return;
    }
    const nbBras = N * C;
    const chargeMax = cb * nbBras;
    const mlineaires = N * C * E;

    const left =
      '<div class="ch-zone ch-zone-left">' +
        '<p class="ch-r-eyebrow ch-reveal">Charge max du cantilever</p>' +
        '<p class="ch-r-total ch-reveal"><span>' + fmtT(chargeMax) + '</span><i class="ch-r-unit">tonnes</i></p>' +
        '<p class="ch-r-sub ch-reveal">' + fmt(cb) + ' kg/bras · ' + nbBras + ' bras · ' + N + ' niveaux × ' + C + ' colonnes</p>' +
        '<div class="ch-lines ch-reveal ch-r2">' +
          '<div class="ch-line"><span class="ch-line-k">Capacité / bras</span><span class="ch-line-v">' + fmt(cb) + ' kg</span></div>' +
          '<div class="ch-line"><span class="ch-line-k">Nombre de bras</span><span class="ch-line-v">' + fmt(nbBras) + '</span></div>' +
          '<div class="ch-line ch-line--em"><span class="ch-line-k">Mètres linéaires</span><span class="ch-line-v">' + fmt1(mlineaires) + ' ml</span></div>' +
        '</div>' +
      '</div>';

    const right =
      '<div class="ch-zone ch-zone-right ch-reveal ch-r3">' +
        '<span class="ch-badge">Rayonnage conseillé</span>' +
        '<h3 class="ch-reco-h">Rack cantilever</h3>' +
        '<p class="ch-reco-d">Idéal pour produits longs : profilés, tubes, bois, panneaux. Capacité réelle selon hauteur des montants et longueur des bras.</p>' +
        '<ul class="ch-stats">' +
          '<li><span>Capacité / bras</span><b>' + fmt(cb) + ' kg</b></li>' +
          '<li><span>Bras</span><b>' + fmt(nbBras) + '</b></li>' +
          '<li><span>Mètres linéaires</span><b>' + fmt1(mlineaires) + ' ml</b></li>' +
          '<li class="win"><span>Charge max</span><b>' + fmtT(chargeMax) + ' T</b></li>' +
        '</ul>' +
        '<a href="/pages/devis" class="ds-cta-btn ds-cta-btn-primary ch-rcta">Obtenir mon devis gratuit ' + arrow + '</a>' +
        '<a href="/collections/all-rayonnage" class="ch-rlink">Voir les cantilevers →</a>' +
      '</div>';

    results.innerHTML = '<div class="ch-rbody">' + left + right + '</div>';
    results.hidden = false;
    summary.innerHTML =
      '<span class="ch-sum-tag">Votre cantilever</span>' +
      '<div class="ch-summary-chips">' +
        '<span class="ch-chip">' + fmt(cb) + ' kg/bras</span>' +
        '<span class="ch-chip">' + N + ' niveaux</span>' +
        '<span class="ch-chip">' + C + ' colonnes</span>' +
        '<span class="ch-chip">entraxe ' + fmt1(E) + ' m</span>' +
      '</div>' +
      '<button type="button" class="ch-modify" id="ca-modify">' + pencil + 'Modifier</button>';
    root.classList.add('is-calculated');
    const mod = $('#ca-modify'); if (mod) mod.addEventListener('click', showForm);
  }

  btn.addEventListener('click', calculate);
  [bras, niveaux, colonnes, entraxe].forEach((i) => i.addEventListener('keypress', (e) => { if (e.key === 'Enter') calculate(); }));
})();
